import { render, staticRenderFns } from "./IconHelp.vue?vue&type=template&id=571d4df5&scoped=true&"
import script from "./IconHelp.vue?vue&type=script&lang=js&"
export * from "./IconHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571d4df5",
  null
  
)

export default component.exports